import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import React from 'react';
import { SubmitButtonWrapper } from './submitButton.styled';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { colors } from '&assets/constants/colors';

interface Props {
	id: string;
	title: string;
	handleClick?: any;
	className?: any;
	titleClassName?: any;
	icon?: any;
	loading?: boolean;
	leftIcon?: any;
	disable?: boolean;
	isWhite?: boolean;
	iconColor?: string;
}

const SubmitButton = (props: Props) => {
	const {
		id,
		title,
		handleClick,
		className,
		titleClassName,
		icon,
		leftIcon,
		disable = false,
		loading = false,
		isWhite = false,
		iconColor = colors.white,
	} = props;
	return (
		<SubmitButtonWrapper
			id={id}
			disabled={disable}
			onClick={!loading && handleClick}
			className={className}
			isWhite={isWhite}
		>
			{leftIcon && leftIcon}
			{loading ? (
				<CircularProgress size={24} color={'inherit'} />
			) : (
				<p className={`btn-title ${titleClassName ? titleClassName : ''}`}>
					{title}
				</p>
			)}
			{icon && (
				<div className="icon-wrapper">
					<ArrowForwardIcon htmlColor={iconColor} />
				</div>
			)}
		</SubmitButtonWrapper>
	);
};

export default SubmitButton;
